import { useNavigate, useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { useLineBasedGrid, useLineBasedGridUpdateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { LineBasedGridMutationData } from "src/hooks/grids";
import { LineBasedGridForm } from "src/forms/LineBasedGridForm";
import { Pane } from "src/components/Pane";
import { isReadOnly } from "src/utils/permission.utils";
import { Spacer } from "src/components/Spacer";
import { ButtonDocs } from "src/components/ButtonDocs";

interface Props {}

export function LineBasedGridPage(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId = "" } = useParams<{ caseId: string }>();
  const { data: acase } = useCase(caseId);
  const { data: lineBasedGrid } = useLineBasedGrid(caseId);

  const updateLineBasedGridMutation = useLineBasedGridUpdateMutation(caseId);

  /**
   * Functions
   */
  function handleSubmit(values: LineBasedGridMutationData) {
    updateLineBasedGridMutation.mutateAsync(values).then(() => handleClose());
  }

  function handleClose() {
    navigate(`/cases/${caseId}/grid-settings`);
  }

  return render();

  function render() {
    if (!lineBasedGrid || !acase) return null;

    return (
      <StyledPane>
        <LineBasedGridForm
          data={lineBasedGrid}
          readOnly={isReadOnly(acase.permissions.updateLineBasedGrid)}
          isLoading={updateLineBasedGridMutation.isLoading}
          errors={updateLineBasedGridMutation.error?.response?.data}
          onSubmit={handleSubmit}
          onClose={handleClose}
        />

        <Spacer />

        <ButtonDocs docsPath="/tutorial/case/case-grid-settings">{t("label.moreInfoAboutGrid")}</ButtonDocs>
      </StyledPane>
    );
  }
}

const StyledPane = styled(Pane)``;
